module.exports = __webpack_public_path__ + "media/images/athletes/2425-a54e8181ae29e3c201f56a6b432bcee4.png";